@use '@/styles/variables' as *;

.overlayWrapper {
    position: fixed;
    top: 0;
    left: 0;
    z-index: $zIndexOverlay;
    width: 100%;
    height: 100dvh;
    overflow: hidden;
    background-color: $overlayBg;
    transition: opacity 0.3s ease-in-out;
    pointer-events: auto;

    &.isolationMode {
        touch-action: none;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
    }
}
